import { render, staticRenderFns } from "./ScPwdSalesBook.vue?vue&type=template&id=2fa2c87a&"
import script from "./ScPwdSalesBook.vue?vue&type=script&lang=js&"
export * from "./ScPwdSalesBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports